import { render, staticRenderFns } from "./HiveVisitsNew.vue?vue&type=template&id=0ae734bb&scoped=true&"
import script from "./HiveVisitsNew.vue?vue&type=script&lang=js&"
export * from "./HiveVisitsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae734bb",
  null
  
)

export default component.exports